export let MapType = /*#__PURE__*/function (MapType) {
  MapType["GAODE"] = "GAODE";
  MapType["MAPBOX"] = "MAPBOX";
  MapType["DEFAULT"] = "DEFAUlTMAP";
  MapType["SIMPLE"] = "SIMPLE";
  MapType["GLOBEL"] = "GLOBEL";
  return MapType;
}({});